module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a662913c45d963c9548f434c825634b7.png";